import { doc, onSnapshot, runTransaction } from "firebase/firestore";
import { FIRESTORE_LOYALTY_USERS_TABLE } from "../../../constants/FirebaseConstants";
import { useAuthContext } from "../../../context/AuthContext";
import { db } from "../../../services/firebase";
import { sendExceptionToSlack } from "../../../services/api/exception";
import useSWRSubscription from "swr/subscription";

export function useLoyaltyUser() {
  const { authUser } = useAuthContext();
  const { data } = useSWRSubscription(
    authUser ? `loyalty-user-${authUser.uid}` : null,
    (key, { next }) => {
      const docRef = doc(db, FIRESTORE_LOYALTY_USERS_TABLE, authUser.uid);
      return onSnapshot(docRef, (doc) => {
        next(null, doc.data());
      });
    },
  );

  const isLoading = !authUser || !data;

  const updateUserPoints = async (points) => {
    const userDocRef = doc(db, FIRESTORE_LOYALTY_USERS_TABLE, authUser.uid);
    try {
      await runTransaction(db, async (transaction) => {
        const userDoc = await transaction.get(userDocRef);

        const newCurrentPoints = userDoc.data().currentPoints - points;
        const newTotalPointsSpent = userDoc.data().totalPointsSpent + points;
        transaction.update(userDocRef, {
          currentPoints: newCurrentPoints,
          totalPointsSpent: newTotalPointsSpent,
        });
      });
      console.log(`Points updated: ${points}`);
    } catch (err) {
      console.error(err);
      sendExceptionToSlack("LoyaltyProgramModal - updateUserData: ", err);
    }
  };

  return { data, updateUserPoints, isLoading };
}
